/**
 * Orders
 */

// React
import React, {
  FunctionComponent,
  useEffect,
  useState,
  useContext
} from 'react'
import useQuery from '../../utils/hook/useQuery'
import { Link, useHistory } from 'react-router-dom'

// Context
import AuthContext, { AuthConsumer } from '../../authContext'

// Redux
import { connect } from 'react-redux'
import { compose } from 'redux'
import {
  getOrdersAction,
  updateOrderStatusActions,
  updateAllOrderStatusActions,
  actionRetrieveRubikaOrdersAction,
  cancelOrderAction,
  getAllOrdersReportAction
} from './actions'
import { Store } from '../../redux/reducers'

// Selector
import { createStructuredSelector } from 'reselect'
import {
  makeSelectOrdersList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectAllOrders,
  makeSelectProcessingCountList,
  makeSelectDeliveredCountList,
  makeSelectDeliveringCountList,
  makeSelectDeliverdPostCountList,
  makeSelectReturnedCountList
} from './selectors'

// UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import {
  Typography,
  Grid,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Card,
  Divider,
  Tooltip,
  Box
} from '@material-ui/core'

// Components
import Filter from '../../utils/filter'
import List from './list'
import FailedOrderList from './failedOrderList'
import Pagination from '@material-ui/lab/Pagination'
import Can from '../../components/Can'
import EXCEL from './excel'
import jMoment from 'moment-jalaali'

// Helper
import {
  removeEmptyValueObject,
  translate,
  checkMatchMedia,
  numberWithCommas
} from '../../utils/helpers'

// Type
import {
  Props,
  SelectorProps,
  Payload,
  Status,
  cancelPayload,
  PayloadAllUpdate
} from './interfaces'

import handleError from '../../utils/handleError'
import VideoModal from '../../components/Modal/video'
import downloadVideo from 'client-sdk/src/video/download'
import CounterCard from '../../components/Cards/counterCard'
import tpsManagementRepository from 'client-sdk/src/Repository/tps-management-repository'
import handleNotfication from '../../utils/handleNotfication'
import RonadIcons from '../../components/iconComponent'
import disableElement from '../../utils/disableElement'
// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      // '@media (max-width: 480px)': {
      //   marginLeft: '75px',
      // },
      backgroundColor: '#fff',
      marginTop: '24px',
      padding: '24px',
      borderRadius: '4px'
    },
    loading: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc'
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    cards: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      transition: 'all .3s',
      '&:hover': {
        transform: 'scale(1.05)',
        // transform: "scaleY(1.05)",
        transition: 'all .3s'
      }
    },
    boxshadow: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      transform: 'scale(1.05)',
      border: '1px solid #3449B0',
      height: '100%'
    },
    iconHeader: {
      position: 'absolute',
      top: '5px',
      right: '5px'
    },
    cardContent: {
      marginTop: '-22px',
      display: 'flex'
    },
    typographyCards: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#383836',
      marginBottom: '24px',
      marginTop: '72px'
      // padding: '8px 24px 8px 50px',
      // marginLeft: '-40px',
    },
    textArea: {
      width: '100%'
    },
    cancelTitle: {
      marginTop: '45px',

      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(1)
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3)
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main
      }
    },
    btnBox: {
      marginTop: '5px',
      padding: '24px 0',
      display: 'flex',
      flexDirection: 'row-reverse',
      // width: '100%',
      '@media (max-width: 480px)': {
        display: 'none',
        flexDirection: 'column-reverse',
        width: '100%'
      }
    },
    titleBar: {
      padding: '5px 2px',
      width: '100%',
      borderRadius: '0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '@media (max-width: 480px)': {
        width: '100%',
        marginLeft: '-70px',

        marginTop: '55px',
        flexDirection: 'column',
        alignItem: 'center',
        fontSize: '12px'
      }
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
      '@media (max-width: 480px)': {
        marginLeft: '-5px',

        fontSize: '12px'
      }
    },
    mobile: {
      maxWidth: '120%',
      margin: '24px 0',
      '@media (max-width: 480px)': {
        marginTop: '140px'
      }
    },
    tabContainer: {
      display: 'flex',
      borderBottom: '1px solid #e9eaf3',
      listStyle: 'none',
      columnGap: '40px',
      padding: 0
    },
    tabItems: {
      fontSize: '16px',
      fontWeight: 600,
      cursor: 'pointer',
      padding: '5px'
    },
    active: {
      color: '#4C599E',
      borderBottom: '3px solid #4C599E'
    }
  })
)

const profile = JSON.parse(localStorage.getItem('profile') || '[]')

const Orders: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext)
  const [filters, setFilters] = useState([] as Filter[])
  const { filtersValues, setFiltersValues } = useQuery({
    failedPage: 0,
    page: 0,
    size: 10,
    'parentId.specified': false
  })
  const [openSize, setOpenSize] = React.useState(false as boolean)
  const [openConfirmCancel, setOpenConfirmCancel] = useState(false as boolean)
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  )
  const [times, setTimes] = useState(
    {} as {
      ronadPartnerId: number
      lastFetchOrderTime: string
      nextRegisterOrderTime: string
    }
  )
  const [video, setVideo] = useState()
  const [videoLoading, setVideoLoading] = useState(false)
  const [isOpenFilter, setIsOpenFilter] = useState(false)
  const [dialog, setDialog] = useState<string>('')
  const [id, setId] = useState(-1 as number)
  const [tab, setTab] = useState(1)
  const [previewState, setPreviewState] = useState('CANCELLED' as Status)
  const [cancelDescription, setCancelDescription] = useState('' as string)
  const [failedOrders, setFailedOrders] = useState<any[]>([])
  const [failedOrdersCount, setFailedOrdersCount] = useState<number>(0)
  const [selectedOrders, setSelectedOrders] = useState<number[]>([])

  const classes = useStyles()

  useEffect(() => {
    if (tab == 1) {
      getOrders()
    } else {
      getFailedOrder()
    }
    setupFilters()
  }, [filtersValues]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getFailedOrder()
    getTimes()
  }, [])

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 })
  }

  const getOrders = () => {
    const { page, size } = filtersValues
    props.ordersDispatch({
      ...filtersValues,
      page,
      size
    })
  }

  const setupFilters = () => {
    Can({
      role: authContext.user.role,
      perform: 'orders:filtersByCenterId',
      yes: () => {
        setFilters([
          {
            type: 'input',
            id: 'customerName.contains',
            label: 'نام سفارش‌دهنده'
          },
          {
            type: 'input',
            id: 'customerMobileNumber.contains',
            label: 'شماره همراه سفارش‌دهنده'
          },
          {
            type: 'number',
            id: 'id.equals',
            label: 'شناسه سفارش'
          },

          {
            type: 'input',
            id: 'trackingCode.contains',
            label: 'کد پیگیری'
          },
          {
            type: 'input',
            id: 'customerNationalCode.contains',
            label: 'کد  ملی'
          },

          {
            type: 'input',
            id: 'centerName.contains',
            label: 'نام مرکز'
          },

          {
            type: 'input',
            id: 'customerProvinceName.contains',
            label: 'نام استان'
          },
          {
            type: 'input',
            id: 'customerCity.contains',
            label: 'نام شهر'
          },

          {
            type: 'date-picker-time',
            id: 'created.greaterThanOrEqual',
            label: 'تاریخ ثبت سفارش از '
          },
          {
            type: 'date-picker-time',
            id: 'created.lessThanOrEqual',
            label: 'تا تاریخ ثبت سفارش  '
          },
          {
            type: 'date-picker',
            id: 'deliveryDate.greaterThanOrEqual',
            label: 'تاریخ تحویل از '
          },
          {
            type: 'date-picker',
            id: 'deliveryDate.lessThanOrEqual',
            label: '  تا تاریخ تحویل '
          },
          {
            type: 'checkbox',
            id: 'status.in',
            label: 'وضعیت سفارش',
            data: [
              'SUPPLYING',
              'ORDERED',
              'PACKAGED',
              'LOADED',
              'DELIVERED_TO_POST',
              'DELIVERED',
              'NOT_DELIVERED',
              'RETURNED',
              'CANCELLED',
              'REQUESTED_TO_RETURN',
              'RETURNED_TO_WAREHOUSE',
              'REQUESTED_TO_RESEND',
              'BUNDLED'
            ],
            translateType: 'Order'
          },
          {
            type: 'checkbox',
            id: 'paymentType.in',
            label: 'شیوه پرداخت',
            data: ['COD', 'ONLINE'],
            translateType: 'COD'
          },
          {
            type: 'input',
            id: 'postTrackingCode.equals',
            label: 'کدرهگیری پست'
          }
        ])
      },
      no: () => {
        setFilters([
          {
            type: 'input',
            id: 'customerName.contains',
            label: 'نام سفارش‌دهنده'
          },
          {
            type: 'input',
            id: 'customerPhoneNumber.contains',
            label: 'شماره همراه سفارش‌دهنده'
          },
          {
            type: 'input',
            id: 'id.equals',
            label: 'شناسه سفارش'
          },

          // {
          //   type: 'input',
          //   id: 'trackingCode.contains',
          //   label: 'شناسه پیگیری',
          // },

          {
            type: 'input',
            id: 'customerNationalCode.contains',
            label: 'کد  ملی'
          },
          // {
          //   type: 'input',
          //   id: 'centerProvince.contains',
          //   label: 'نام  استان',
          // },
          // {
          //   type: 'input',
          //   id: 'centerCity.contains',
          //   label: 'نام  شهر',
          // },

          // {
          //   type: 'date-picker-time',
          //   id: 'created.greaterThanOrEqual',
          //   label: 'تاریخ ثبت سفارش از ',

          // }, {
          //   type: 'date-picker-time',
          //   id: 'created.lessThanOrEqual',
          //   label: 'تا تاریخ ثبت سفارش  ',

          // },
          {
            type: 'date-picker',
            id: 'deliveryDate.greaterThanOrEqual',
            label: 'تاریخ تحویل از '
          },
          {
            type: 'date-picker',
            id: 'deliveryDate.lessThanOrEqual',
            label: '  تا تاریخ تحویل '
          },
          {
            type: 'checkbox',
            id: 'status.in',
            label: 'وضعیت سفارش',
            data: [
              'ORDERED',
              'DELIVERED_TO_POST',
              'DELIVERED_TO_CENTER',
              'SUPPLIED_IN_CENTER',
              'PACKAGED',
              'BUNDLED',
              'LOADED',
              'ARRIVED',
              'DELIVERED',
              'NOT_DELIVERED',
              'RETURNED',
              'SUPPLYING',
              'CANCELLED',
              'REQUESTED_TO_RETURN',
              'RETURNED_TO_WAREHOUSE',
              'REQUESTED_TO_RESEND'
            ],
            translateType: 'Order'
          },
          {
            type: 'checkbox',
            id: 'paymentType.in',
            label: 'شیوه پرداخت',
            data: ['COD', 'ONLINE'],
            translateType: 'COD'
          }
        ])
      }
    })
  }

  const handleCancelOrder = async () => {
    await props.cancelOrderDispatch({
      id,
      body: { description: cancelDescription }
    })
    setCancelDescription('')
    getOrders()
    setOpenConfirmCancel(false)
  }

  const handleCardClose = () => {
    delete filtersValues['status.in']
    setFiltersValues({
      ...removeEmptyValueObject(filtersValues),

      page: 0,
      size: 10
    })
  }

  const handleCardClick = (name: any) => {
    switch (name) {
      case 'progress':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['ASSIGNED', 'PICKED', 'PACKAGED', 'BUNDLED'],

          page: 0,
          size: 10
        })
        break
      case 'courier':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['LOADED', 'DELIVERED_TO_COURIER'],

          page: 0,
          size: 10
        })
        break
      case 'delivered':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['DELIVERED'],
          page: 0,
          size: 10
        })
        break
      case 'post':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['DELIVERED_TO_POST'],
          page: 0,
          size: 10
        })
        break
      case 'returned':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['RETURNED'],
          page: 0,
          size: 10
        })
        break
    }
  }

  const changeStatusOrder = () => {
    props.updateOrderStatusDispatch({
      id,
      body: { status: previewState, description: '' },
      pagination: filtersValues
    })
    setOpenConfirmUpdateState(false)
  }

  const changeStatusOrderWhitId = (data: any) => {
    const { ids, status, description } = data
    props.updateAllOrderStatusDispatch({
      ids,
      status,
      description,
      pagination: filtersValues
    })
    setOpenConfirmUpdateState(false)
  }

  const handleOpenConfirmCancele = (id: number) => {
    setOpenConfirmCancel(true)
    setId(id)
  }

  const handleOpenConfirmUpdateState = (data: { id: number; body: Status }) => {
    setOpenConfirmUpdateState(true)
    setId(data.id)
    setPreviewState(data.body)
  }

  const handleClose = () => {
    setOpenConfirmCancel(false)
    setOpenConfirmUpdateState(false)
    setOpenSize(false)
  }

  const findOrderStatus = (id: number) => {
    const status = props.ordersList.find((order) => order.id === id)?.status
    return status && translate(status, 'order')
  }

  const handleChangeSizePage = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value })
  }

  const checkActiveCard = (name: string) => {
    const status = filtersValues['status.in']?.split(',') || []
    switch (name) {
      case 'progress':
        return (
          status.includes('ASSIGNED') &&
          status.includes('PICKED') &&
          status.includes('PACKAGED') &&
          status.includes('BUNDLED')
        )
      case 'courier':
        return (
          status.includes('LOADED') && status.includes('DELIVERED_TO_COURIER')
        )
      case 'delivered':
        return status.includes('DELIVERED')
      case 'post':
        return status.includes('DELIVERED_TO_POST')
      case 'returned':
        return status.includes('RETURNED')
    }
  }

  const fetchVideo = async () => {
    try {
      setVideoLoading(true)
      const response = await downloadVideo('BATCH_ORDER')
      const reader = response?.body?.getReader()
      let buffer = []
      while (1) {
        const { value, done } = await reader?.read()
        if (done) {
          const blob = new Blob(buffer)
          const blobUrl = URL.createObjectURL(blob)
          setVideo(blobUrl)
          break
        }
        buffer.push(value)
      }
      setVideoLoading(false)
    } catch (err) {
      setVideoLoading(false)
      handleError(err)
    }
  }

  const onVideoOpen = () => {
    setDialog('VIDEO')
    fetchVideo()
  }

  const getFailedOrder = async () => {
    const { failedPage, size } = filtersValues
    try {
      const response = await tpsManagementRepository.getTpsFaildOrder({
        payload: { page: failedPage, size }
      })
      setFailedOrders(response.data)
      setFailedOrdersCount(response.headers['x-total-count'])
    } catch (error) {
      handleError(error)
    }
  }

  const retryFailedOrder = async (ids: string[]) => {
    try {
      const response = await tpsManagementRepository.retryFaildOrder({
        payload: { externalOrderIds: ids.join(',') }
      })
      getFailedOrder()
    } catch (error) {
      handleError(error)
    }
  }

  const retryAllFailedOrder = () => {
    retryFailedOrder(failedOrders.map((el) => el.externalOrderId))
  }

  const getTimes = async () => {
    try {
      const response = await tpsManagementRepository.getRegistrationTimes()
      setTimes(response.data)
    } catch (error) {
      // handleError(error)
    }
  }

  const handlerSelectedOrdersId = (ordersId: number[]) => {
    setSelectedOrders(ordersId)
  }

  return (
    <AuthConsumer>
      {({ user }) => (
        <>
          <Typography variant='h6' component='h1'>
            {`مدیریت سفارش‌ها`}
          </Typography>
          <div className={classes.root}>
            {tab == 1 && (
              <Grid container spacing={2}>
                <Grid item md={6} lg xs={12}>
                  <CounterCard
                    isActive={checkActiveCard('progress')}
                    data={numberWithCommas(props.processingCount)}
                    handleClick={() => handleCardClick('progress')}
                    label='در حال پردازش'
                    icon='boxesOutline'
                    iconColor='#3449B0'
                    color='#3449B01A'
                    dActiveCard={handleCardClose}
                  />
                </Grid>
                <Grid item md={6} lg xs={12}>
                  <CounterCard
                    isActive={checkActiveCard('courier')}
                    data={numberWithCommas(props.deliveringCount)}
                    handleClick={() => handleCardClick('courier')}
                    label='تحویل پیک شده'
                    iconColor='#F08354'
                    icon='truckSide'
                    color='#F083541A'
                    dActiveCard={handleCardClose}
                  />
                </Grid>
                <Grid item md={6} lg xs={12}>
                  <CounterCard
                    isActive={checkActiveCard('post')}
                    data={numberWithCommas(props.deliverdPostCount)}
                    handleClick={() => handleCardClick('post')}
                    label='تحویل پست'
                    iconColor='#E63312'
                    icon='mailbox'
                    color='#FDCACA33'
                    dActiveCard={handleCardClose}
                  />
                </Grid>
                <Grid item md={6} lg xs={12}>
                  <CounterCard
                    isActive={checkActiveCard('delivered')}
                    data={numberWithCommas(props.deliveredCount)}
                    handleClick={() => handleCardClick('delivered')}
                    label='تحویل مشتری'
                    iconColor='#25368C'
                    icon='smile'
                    color='#25368C1A'
                    dActiveCard={handleCardClose}
                  />
                </Grid>
                <Grid item md={6} lg xs={12}>
                  <CounterCard
                    isActive={checkActiveCard('returned')}
                    data={props.returnedCount}
                    handleClick={() => handleCardClick('returned')}
                    label='بازگردانده شده'
                    icon='undo'
                    iconColor='#789ECD'
                    color='#789ECD22'
                    dActiveCard={handleCardClose}
                  />
                </Grid>
              </Grid>
            )}
            {tab == 2 && (
              <Card style={{ padding: '0 24px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <RonadIcons name='refresh' size={0.9} />
                  <p
                    style={{
                      color: '#217AFF',
                      fontSize: '16px',
                      marginRight: '12px'
                    }}
                  >
                    آخرین به‌روزرسانی -{' '}
                    {jMoment(
                      times?.lastFetchOrderTime?.split('T')[0],
                      'YYYY/M/D'
                    )
                      .locale('fa')
                      .format('jYY/jMM/jDD')}{' '}
                    -{' '}
                    {jMoment(
                      times?.lastFetchOrderTime?.split('T')[1],
                      'HH:mm:ss'
                    )
                      .locale('fa')
                      .format('HH:mm')}
                  </p>
                </div>
                <hr style={{ color: 'rgba(233, 234, 243, 0.17)' }} />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <RonadIcons name='refresh' size={0.9} />
                  <p
                    style={{
                      color: '#329926',
                      fontSize: '16px',
                      marginRight: '12px'
                    }}
                  >
                    به‌روزرسانی بعدی -{' '}
                    {jMoment(
                      times?.nextRegisterOrderTime?.split('T')[0],
                      'YYYY/M/D'
                    )
                      .locale('fa')
                      .format('jYY/jMM/jDD')}{' '}
                    -{' '}
                    {jMoment(
                      times?.nextRegisterOrderTime?.split('T')[1],
                      'HH:mm:ss'
                    )
                      .locale('fa')
                      .format('HH:mm')}
                  </p>
                </div>
              </Card>
            )}
            <div style={{ marginTop: '20px' }}>
              <Typography className={classes.typographyCards}>
                لیست سفارش‌ها
              </Typography>
              <ul className={classes.tabContainer}>
                <li
                  onClick={() => setTab(1)}
                  className={
                    classes.tabItems + ' ' + (tab == 1 && classes.active)
                  }
                >
                  سفارش‌ها
                </li>
                <li
                  onClick={() => {
                    times.lastFetchOrderTime
                      ? setTab(2)
                      : handleNotfication(
                          'شما هنوز فروشگاهی در قسمت یکپارچگی ثبت نکرده‌اید.',
                          'error'
                        )
                  }}
                  className={
                    classes.tabItems + ' ' + (tab == 2 && classes.active)
                  }
                >
                  اعلان‌های یکپارچگی
                </li>
              </ul>
              {tab == 1 && (
                <>
                  {' '}
                  <div className={classes.btnBox}>
                    <Can
                      role={user.role}
                      perform='orders:grouping-create'
                      profile={profile}
                      yes={() => (
                        <>
                          <Can
                            role={user.role}
                            perform='orders:create'
                            profile={profile}
                            yes={() => (
                              <>
                                <Button
                                  variant='contained'
                                  color='primary'
                                  onClick={() =>
                                    props.history.push('/orders-create')
                                  }
                                  endIcon={
                                    <RonadIcons
                                      name='plus'
                                      size={0.7}
                                      className='text-white'
                                    />
                                  }
                                  size={
                                    checkMatchMedia('(max-width: 1024px)')
                                      ? 'small'
                                      : 'large'
                                  }
                                >{`ایجاد سفارش `}</Button>
                              </>
                            )}
                            no={() => (
                              <Button
                                variant='contained'
                                color='primary'
                                disabled
                                endIcon={
                                  <RonadIcons
                                    name='plus'
                                    size={0.7}
                                    className='text-white'
                                  />
                                }
                                size={
                                  checkMatchMedia('(max-width: 1024px)')
                                    ? 'small'
                                    : 'large'
                                }
                              >{`ایجاد سفارش `}</Button>
                            )}
                          />
                          {disableElement(profile) ? (
                            <Button
                              variant='contained'
                              color='primary'
                              style={{ marginLeft: '8px' }}
                              onClick={() =>
                                props.history.push('/create-grouping-order')
                              }
                              endIcon={
                                <RonadIcons
                                  name='plus'
                                  size={0.7}
                                  className='text-white'
                                />
                              }
                              size={
                                checkMatchMedia('(max-width: 1024px)')
                                  ? 'small'
                                  : 'large'
                              }
                            >{`ایجاد گروهی سفارش`}</Button>
                          ) : (
                            <Button
                              variant='contained'
                              color='primary'
                              style={{ marginLeft: '8px' }}
                              onClick={() =>
                                props.history.push('/create-grouping-order')
                              }
                              endIcon={
                                <RonadIcons
                                  name='plus'
                                  size={0.7}
                                  className='text-white'
                                />
                              }
                              size={
                                checkMatchMedia('(max-width: 1024px)')
                                  ? 'small'
                                  : 'large'
                              }
                            >{`ایجاد گروهی سفارش`}</Button>
                          )}
                        </>
                      )}
                    />
                    <Can
                      role={user.role}
                      perform='orders:downloadReportCSV'
                      yes={() => (
                        <>
                          <EXCEL
                            ordersDispatch={props.allOrdersDispatch}
                            data={props.allOrders}
                            filtersValues={filtersValues}
                            loading={props.loading}
                          />
                          {/* <ExelExport
                    data={convertArrayItemsToString()}
                    loading={props.loading}
                    filtersValues={filtersValues}
                    handleRequest={props.allOrdersDispatch}
                  /> */}
                        </>
                      )}
                    />
                    {['125', '66', '5', '124'].includes(
                      authContext.user.partnerId
                    ) && (
                      <Can
                        role={user.role}
                        perform='orders:create'
                        yes={() => (
                          <>
                            <Button
                              variant='contained'
                              color='primary'
                              style={{ marginLeft: '8px' }}
                              onClick={() => props.history.push('/crossdock')}
                              endIcon={
                                <RonadIcons
                                  name='plus'
                                  size={0.7}
                                  className='text-white'
                                />
                              }
                              size={
                                checkMatchMedia('(max-width: 1024px)')
                                  ? 'small'
                                  : 'large'
                              }
                            >{`ایجاد سفارش ارسال مستقیم`}</Button>
                          </>
                        )}
                      />
                    )}
                    <Button
                      variant='contained'
                      color='primary'
                      style={{ marginLeft: '8px' }}
                      onClick={() => setIsOpenFilter((prev) => !prev)}
                      endIcon={
                        <RonadIcons
                          name='magnifier'
                          size={0.7}
                          className='text-white'
                        />
                      }
                      size={
                        checkMatchMedia('(max-width: 1024px)')
                          ? 'small'
                          : 'large'
                      }
                    >{`جستجو`}</Button>
                  </div>
                  <Filter
                    isOpenFilters={isOpenFilter}
                    setIsOpenFilter={setIsOpenFilter}
                    filters={filters}
                    onFilter={(filtervalues: any) => {
                      setFiltersValues({
                        ...removeEmptyValueObject(filtervalues),
                        page: 0,
                        size: 10
                      })
                    }}
                    mainFiltersCount={0}
                    baseFilter={{
                      type: 'input',
                      id: 'trackingCode.contains',
                      placeholder: 'کد پیگیری'
                    }}
                    filterValues={filtersValues}
                  />
                  {selectedOrders.length > 0 && (
                    <Grid>
                      <Box style={{ textAlign: 'end', margin: '20px 0' }}>
                        <Link
                          to={`/orders/exit-order-recipt/${selectedOrders.join()}`}
                          target='_blank'
                          style={{ textDecoration: 'none'}}
                        >
                          <Button
                            size='medium'
                            variant='outlined'
                            color='primary'
                            startIcon={
                              <RonadIcons name="printer" size={0.7} />
                            }
                          >
                            {'چاپ برچسب'}
                          </Button>
                        </Link>
                      </Box>
                    </Grid>
                  )}
                  <Grid container>
                    <Grid container item xs={12} md={12} lg={12}>
                      {props.loading ? (
                        <div className={classes.loading}>
                          <CircularProgress />
                        </div>
                      ) : (
                        <>
                          {props.ordersList?.length > 0 ? (
                            <List
                              data={props.ordersList}
                              handlerSelectedOrdersId={handlerSelectedOrdersId}
                              handleConfirmCanceleBox={handleOpenConfirmCancele}
                              changeStatusOrderWhitId={changeStatusOrderWhitId}
                              handleOpenConfirmUpdateState={
                                handleOpenConfirmUpdateState
                              }
                            />
                          ) : (
                            <Typography variant='h3' component='div'>
                              سفارشی موجود نیست
                            </Typography>
                          )}
                        </>
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      style={{ padding: '20px 10px 0 10px' }}
                    >
                      {props.ordersList.length > 0 && (
                        <FormControl
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                          }}
                        >
                          <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                            {' '}
                            تعداد نمایش در هر صفحه:
                          </div>
                          <Select
                            open={openSize}
                            onClose={handleClose}
                            onOpen={() => setOpenSize(true)}
                            value={filtersValues.size}
                            onChange={handleChangeSizePage}
                          >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </Grid>
                    <Grid
                      xs={12}
                      sm={6}
                      container
                      item
                      direction='row-reverse'
                      style={{ padding: '20px 10px 0 10px' }}
                    >
                      {props.ordersList.length > 0 && (
                        <Pagination
                          className={classes.pagination}
                          count={Math.ceil(props.count / filtersValues.size)}
                          color='secondary'
                          page={filtersValues.page + 1}
                          onChange={handleChangePage}
                        />
                      )}
                    </Grid>
                  </Grid>{' '}
                </>
              )}
              {tab == 2 && (
                <>
                  {' '}
                  <div className={classes.btnBox}>
                    <Button
                      variant='contained'
                      color='primary'
                      onClick={retryAllFailedOrder}
                      endIcon={
                        <RonadIcons
                          name='refresh'
                          size={0.9}
                          className='text-white'
                        />
                      }
                      size={
                        checkMatchMedia('(max-width: 1024px)')
                          ? 'small'
                          : 'large'
                      }
                    >{`تلاش مجدد همه`}</Button>
                    {/* <ProgressBar percent={50}/> */}
                  </div>
                  <Grid container>
                    <Grid container item xs={12} md={12} lg={12}>
                      {props.loading ? (
                        <div className={classes.loading}>
                          <CircularProgress />
                        </div>
                      ) : (
                        <>
                          {failedOrders.length > 0 ? (
                            <FailedOrderList
                              data={failedOrders}
                              retryAction={retryFailedOrder}
                            />
                          ) : (
                            <Typography variant='h3' component='div'>
                              سفارشی موجود نیست
                            </Typography>
                          )}
                        </>
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      style={{ padding: '20px 10px 0 10px' }}
                    >
                      {failedOrders.length > 0 && (
                        <FormControl
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                          }}
                        >
                          <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                            {' '}
                            تعداد نمایش در هر صفحه:
                          </div>
                          <Select
                            open={openSize}
                            onClose={handleClose}
                            onOpen={() => setOpenSize(true)}
                            value={filtersValues.size}
                            onChange={handleChangeSizePage}
                          >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </Grid>
                    <Grid
                      xs={12}
                      sm={6}
                      container
                      item
                      direction='row-reverse'
                      style={{ padding: '20px 10px 0 10px' }}
                    >
                      {failedOrders.length > 0 && (
                        <Pagination
                          className={classes.pagination}
                          count={Math.ceil(
                            failedOrdersCount / filtersValues.size
                          )}
                          color='secondary'
                          page={filtersValues.failedPage + 1}
                          onChange={(e, page) =>
                            setFiltersValues({
                              ...filtersValues,
                              failedPage: page - 1
                            })
                          }
                        />
                      )}
                    </Grid>
                  </Grid>{' '}
                </>
              )}
            </div>

            <Dialog
              open={openConfirmCancel}
              onClose={handleClose}
              aria-labelledby='responsive-dialog-title'
            >
              <DialogContent>
                <div
                  style={{
                    position: 'absolute',
                    left: '3px',
                    top: '10px',
                    zIndex: 10
                  }}
                >
                  {handleClose ? (
                    <IconButton
                      aria-label='close'
                      // className={classes.closeButton}
                      onClick={handleClose}
                    >
                      <RonadIcons name='times' size={0.8} />
                    </IconButton>
                  ) : null}
                </div>

                <div
                  className={classes.cancelTitle}
                >{`از لغو سفارش با شناسه ${id} مطمئن هستید؟`}</div>
                <Grid item xs={12} style={{ marginTop: '16px' }}>
                  <TextField
                    variant='outlined'
                    className={classes.textArea}
                    placeholder={`علت لغو...`}
                    value={cancelDescription}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setCancelDescription(e.target.value)
                    }
                  />
                </Grid>
                <Divider style={{ width: '100%', marginTop: '16px' }} />
              </DialogContent>
              <DialogActions>
                <Grid
                  container
                  spacing={2}
                  justifyContent='center'
                  style={{ textAlign: 'center', marginBottom: '8px' }}
                >
                  <Grid item xs={12}>
                    <Button
                      style={{ marginLeft: '8px' }}
                      autoFocus
                      onClick={handleClose}
                      variant='outlined'
                      color='primary'
                      size='large'
                      data-cy='closeCancelation'
                    >
                      {`انصراف
`}
                    </Button>
                    <Button
                      variant='contained'
                      onClick={handleCancelOrder}
                      disabled={!(cancelDescription.length > 0)}
                      size='large'
                      data-cy='submitCancelation'
                      color='primary'
                    >
                      {`لغو سفارش`}
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </Dialog>
            <VideoModal
              src={video}
              onClose={() => setDialog('')}
              open={dialog === 'VIDEO'}
              loading={videoLoading}
            />
            <Dialog
              fullWidth
              open={openConfirmUpdateState}
              onClose={handleClose}
              aria-labelledby='responsive-dialog-title'
            >
              <DialogContent>
                <div
                  style={{
                    position: 'absolute',
                    left: '17px',
                    zIndex: 10
                  }}
                >
                  {handleClose ? (
                    <IconButton
                      aria-label='close'
                      // className={classes.closeButton}
                      onClick={handleClose}
                    >
                      <RonadIcons name='times' size={0.8} />
                    </IconButton>
                  ) : null}
                </div>
                <div className={classes.editIcon}>
                  <RonadIcons name='pencil' size={4} />
                </div>
                <div className={classes.cancelTitle}>
                  {`از تغییر تگ وضعیت سفارش
            با شناسه  ${id} از
"${id > -1 && findOrderStatus(id)}"
به
" ${translate(previewState.replace(/"/g, '') as Status, 'order')}"


مطمئن هستید؟`}
                </div>
              </DialogContent>
              <DialogActions className={classes.actionsBox}>
                <Grid container spacing={2}>
                  <Grid item xs={8}>
                    <Button
                      fullWidth
                      autoFocus
                      onClick={handleClose}
                      variant='contained'
                      color='secondary'
                      size='large'
                      data-cy='closeChangeTag'
                    >
                      {`خیر`}
                    </Button>
                  </Grid>
                  <Grid item xs={4}>
                    <Button
                      fullWidth
                      variant='contained'
                      onClick={changeStatusOrder}
                      size='large'
                      data-cy='submitChangeTag'
                    >
                      {`بله`}
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </Dialog>
          </div>
        </>
      )}
    </AuthConsumer>
  )
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectOrdersList(),
  allOrders: makeSelectAllOrders(),
  count: makeSelectCountList(),
  deliveringCount: makeSelectDeliveringCountList(),
  deliveredCount: makeSelectDeliveredCountList(),
  processingCount: makeSelectProcessingCountList(),
  deliverdPostCount: makeSelectDeliverdPostCountList(),
  returnedCount: makeSelectReturnedCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError()
})

function mapDispatchToProps(dispatch: Function) {
  return {
    ordersDispatch: (payload: Payload) => dispatch(getOrdersAction(payload)),
    allOrdersDispatch: (payload: Payload) =>
      dispatch(getAllOrdersReportAction(payload)),
    updateOrderStatusDispatch: (payload: {
      id: number
      body: string
      pagination: object
    }) => dispatch(updateOrderStatusActions(payload)),
    updateAllOrderStatusDispatch: (payload: PayloadAllUpdate) =>
      dispatch(updateAllOrderStatusActions(payload)),
    actionRetrieveRubikaOrdersDispatch: (payload: {
      date?: String
      from?: number
      to?: number
    }) => dispatch(actionRetrieveRubikaOrdersAction(payload)),
    cancelOrderDispatch: (payload: cancelPayload) =>
      dispatch(cancelOrderAction(payload))
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
export default compose(withConnect)(Orders)
